import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ChangeSessionComponent } from "./change-session/change-session.component";

const routes: Routes = [
	{
		path: "",
		component: ChangeSessionComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ChangeSessionPageRoutingModule {}
